import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/Primitives/Card"
import { Button } from "@/components/Primitives/Button"
import { MarkdownRenderer } from "@/components/Primitives/MarkdownRenderer"
import { cn } from "@/lib/utils/utils"
import { useConfig } from "@/hooks/useConfig"

interface ImageCardProps {
  title: string
  description: string
  imageSrc: string
  imageAlt: string
  onPreview?: () => void
  className?: string
  buttonText?: string
}

export function ImageCard({
  title,
  description,
  imageSrc,
  imageAlt,
  onPreview,
  className,
  buttonText,
}: ImageCardProps) {
  const { t } = useConfig()
  return (
    <Card
      className={cn(
        "overflow-hidden bg-neutral-100 p-0 pb-4 md:flex-row",
        className,
      )}
    >
      <div className="relative w-full h-48 md:h-[25.75rem] md:w-[45%]">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-4 md:pt-10 md:flex md:flex-col md:justify-between md:w-[55%]">
        <div>
          <CardHeader>
            <CardTitle className="md:text-[2.5rem]">{title}</CardTitle>
          </CardHeader>
          <CardContent>
            <MarkdownRenderer content={description} />
          </CardContent>
        </div>
        <CardFooter className="justify-end md:px-0 mt-6">
          <Button onClick={onPreview} type="button">
            {buttonText || t("config_button_quest_preview")}
          </Button>
        </CardFooter>
      </div>
    </Card>
  )
}
